import React, { memo } from 'react';
import { Box, Button, Image, Text } from '@betty/moonlight';
import { useDispatch } from '@betty/toolkit/state';
import { openChat } from '@betty/chat/state';

function ContactSupportBottomSheet() {
  const dispatch = useDispatch();

  return (
    <Box alignItems="center">
      <Image name="common.LimitReachedClock" width={100} height={100} />
      <Box width="100%" alignItems="center" gap="space-300">
        <Text
          variant="h3"
          color="darkSurfacePrimary"
          locNS="responsibleGaming"
          locKey="takeBreather"
        />
        <Text
          variant="body-m"
          color="darkSurfacePrimary"
          textAlign="center"
          locNS="responsibleGaming"
          locKey="getInTouchWithYou"
        />
        <Button
          locNS="common"
          locKey="liveChat"
          width="100%"
          onPress={() => dispatch(openChat())}
        />
      </Box>
    </Box>
  );
}

export default memo(ContactSupportBottomSheet);
